const func = $target => {
	var $modal = $('.modal#deleteAddressModal'),
		$input = $modal.find('input#deleteAddressId');

	$modal
		.on('show.bs.modal', function(e) {
			$input.val($(e.relatedTarget).data('address-id'));
		})
		.on('hidden.bs.modal', function(e) {
			$input.val('');
		});
};

export default func;
